module.exports = __webpack_public_path__ + "img/sidebar-1.95b27621.jpg";